/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_Exercise_LabelInputs */

const fr_leaderboard_exercise_label = /** @type {(inputs: Leaderboard_Exercise_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice`)
};

/**

* @param {Leaderboard_Exercise_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_exercise_label = /** @type {((inputs?: Leaderboard_Exercise_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_Exercise_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_exercise_label(inputs)
});